<template>
  <!-- eslint-disable -->
  <div>
    <el-row>
      <!--linea 1-->
      <el-col :offset="12" :md="12" class="text_align_right">
        <span
          v-if=" !isActiveContract(actualContract)"
          class="font_size_22px inventario_estado inventario_estado_vencido"
        >{{ $t('Vencido') }}</span>
        <span
          :class="`font_size_22px inventario_estado inventario_estado_${inventario.status}`"
        >{{ $t(inventario_estado[inventario.status]) }}</span>
        <el-button
          class="button_img margen_r_l_20px"
          v-if="inventario.status == 1"
          @click="downloadPDFReview"
          :loading="isLoadingPDF"
          size="small"
        >
          <img class="img_pdf" src="@/assets/icons/pdf-file.svg" />
          <br />
          <span>{{ $t('Revisión') }}</span>
        </el-button>

        <el-button
          class="button_img margen_r_l_20px"
          v-if="inventario.status == 2"
          @click="downloadPDF"
          :loading="isLoadingPDF"
          size="small"
        >
          <img class="img_pdf" src="@/assets/icons/pdf-file.svg" />
          <br />
          <span>{{ $t('Completo') }}</span>
        </el-button>
        <el-button
          class="button_img"
          size="small"
          v-if="(inventario.status == 2 || inventario.status == 3) && medioambiental"
          @click="downloadPDFMedioambiente"
          :loading="isLoadingPDFMedioambiente"
        >
          <img class="img_pdf" src="@/assets/icons/pdf-file.svg" />
          <br />
          <span>{{ $t('Medioambiente') }}</span>
        </el-button>
        <el-button
          v-if="
              (inventario.status != 0)
              && (isAdmin === true || rolesCoordinator[$store.getters.role.role])"
          @click="changeStatus('borrador')"
          size="small"
          class="button_img"
        >
          <img class="img_pdf" src="@/assets/change.svg" />
          <br />
          {{ $t('Cambiar a borrador') }}
        </el-button>
      </el-col>
    </el-row>
    <br />
    <br />
    <el-table
      :data="getInventario()"
      style="width: 100%; border: 1px solid rgb(7, 116, 141);"
      :header-cell-style="function () { return 'background-color: rgb(7, 116, 141);color: white; padding: 0px;'}"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table
            :data="scope.row.riesgos"
            style="width: 100%"
            :header-cell-style="function () { return 'background-color: rgb(80, 161, 179);color: white; padding: 0px;'}"
          >
            <el-table-column type="expand" width="30">
              <template
                slot-scope="props"
                v-if="!props.row.tipo || filtro_tipo_riesgo[props.row.tipo.toLowerCase()]"
              >
                <el-row :gutter="20">
                  <el-col :sm="8">
                    <h4>{{$t('Causas')}}</h4>
                    <ol>
                      <li v-for="(causa, ic) in props.row.causas" :key="ic">{{ causa.nombre }}</li>
                    </ol>
                  </el-col>
                  <el-col :sm="8">
                    <h4>{{$t('Controles Preventivos')}}</h4>
                    <ol>
                      <li
                        v-for="(control, ic) in getControlesPreventivos(props.row)"
                        :key="ic"
                        :class="tablaControlCritico(control)"
                      >{{ control.nombre }}</li>
                    </ol>
                  </el-col>
                  <el-col :sm="8">
                    <h4>{{$t('Controles Mitigatorios')}}</h4>
                    <ol>
                      <li
                        v-for="(control, ic) in getControlesMitigadores(props.row)"
                        :key="ic"
                        :class="tablaControlCritico(control)"
                      >{{control.nombre}}</li>
                    </ol>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="Acción"
              width="170"
              v-if="inventario.status.toString() !== '2' && scope.row.paso === -1 && isCoordinatorRole($store.getters.role.role) || $store.getters.role.admin"
            >
              <template slot-scope="props">
                <div v-if="!scope.row.aprobado && isActiveContract(actualContract)">
                  <el-button
                    style="width: 145px; margin-bottom: 5px; border: 1px solid white;"
                    size="small"
                    icon="el-icon-delete"
                    type="danger"
                    class="buttonAction"
                    @click="setTask(scope.row), deleteRisk(props.row)"
                  >{{ $t('Eliminar') }}</el-button>
                  <br />
                  <el-button
                    style="width: 145px; border: 1px solid white;"
                    size="small"
                    icon="el-icon-edit"
                    type="primary"
                    class="buttonAction"
                    @click="setTask(scope.row), changeRisk(props.row)"
                  >{{ $t('Modificar') }}</el-button>
                </div>
                <el-tag v-else type="info">NO DISPONIBLE</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Nombre del riesgo" prop="nombre"></el-table-column>
            <el-table-column align="center" label="Categoría" width="150">
              <template slot-scope="scope">{{scope.row.tipo ? MaysPrimera(scope.row.tipo) : ""}}</template>
            </el-table-column>
            <el-table-column align="center" label="Sin Controles">
              <el-table-column align="center" label="Severidad" width="140">
                <template
                  slot-scope="scope"
                >{{scope.row.sin_controles ? scope.row.sin_controles.severidad : "---"}}</template>
              </el-table-column>
              <el-table-column align="center" label="Probabilidad" width="140">
                <template
                  slot-scope="scope"
                >{{scope.row.sin_controles ? scope.row.sin_controles.probabilidad : "---"}}</template>
              </el-table-column>
              <el-table-column align="center" label="Indice de Riesgo" width="140">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.sin_controles"
                  >{{(scope.row.sin_controles.probabilidad * scope.row.sin_controles.severidad) || "---"}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="Con Controles">
              <el-table-column align="center" label="Severidad" width="140">
                <template
                  slot-scope="scope"
                >{{scope.row.con_controles ? scope.row.con_controles.severidad : "---"}}</template>
              </el-table-column>
              <el-table-column align="center" label="Probabilidad" width="140">
                <template
                  slot-scope="scope"
                >{{scope.row.con_controles ? scope.row.con_controles.probabilidad : "---"}}</template>
              </el-table-column>
              <el-table-column align="center" label="Indice de Riesgo" width="140">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.con_controles"
                  >{{(scope.row.con_controles.probabilidad * scope.row.con_controles.severidad) || "---"}}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Acción')"
        v-if="this.$store.getters.inventario.status == 1 && isActiveContract(contract)"
        align="center"
        width="175"
      >
        <template slot-scope="scope">
          <el-button
            style="width: 145px; margin-bottom: 5px;"
            size="small"
            :id="scope.row._id"
            v-if="canReviewTask(scope.row, workflows, contract) || isAdmin"
            icon="el-icon-check"
            type="primary"
            class="buttonAction"
            @click="openDialogVerificarEstado(scope.row)"
          >{{ $t('Revisar') }}</el-button>
          <el-tag
            v-if="!canReviewTask(scope.row, workflows, contract) && !isCoordinatorRole($store.getters.role.role) && !isAdmin"
            type="danger"
          >NO DISPONIBLE</el-tag>
          <br />
          <el-button
            style="width: 145px;"
            @click="saveVerificarEstadoCoordinador(scope.row)"
            icon="el-icon-success"
            size="small"
            type="primary"
            v-if="scope.row.paso === -1 && isCoordinatorRole($store.getters.role.role) || isAdmin"
          >Enviar corrección</el-button>
          <el-tag
            v-if="scope.row.paso !== -1 && isCoordinatorRole($store.getters.role.role)"
            type="danger"
          >NO DISPONIBLE</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Nombre de tarea" prop="nombre" min-width="100"></el-table-column>
      <el-table-column label="Estado de la tarea">
        <template slot-scope="scope">
          <div style="font-size: 12px;">
            <span>
              <b>ACTUAL REVISOR</b>
              <br />
            </span>
            <span v-if="actualRevisor(scope.row)">{{actualRevisor(scope.row).toUpperCase()}}</span>
            <el-tag type="warning" size="mini" v-else>SIN ACTUAL REVISOR</el-tag>
            <br />
            <span>
              <b>PRÓXIMO REVISOR</b>
              <br />
            </span>
            <span v-if="proximoRevisor(scope.row)">{{proximoRevisor(scope.row).toUpperCase()}}</span>
            <el-tag type="warning" size="mini" v-else>SIN PRÓXIMOS REVISORES</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Última revisión">
        <template slot-scope="scope">
          <span
            v-if="scope.row.ultimo_revisor || scope.row.ultimo_rol_revisor || scope.row.ultima_revision"
          >
            <b>
              <span v-if="scope.row.ultimo_revisor">{{scope.row.ultimo_revisor}}</span>
            </b>
            <br />
            <span v-if="scope.row.ultimo_rol_revisor">{{getRole(scope.row.ultimo_rol_revisor)}}</span>
            <br />
            <span v-if="scope.row.ultima_revision">{{scope.row.ultima_revision}}</span>
            <br />
          </span>
          <el-tag type="primary" v-else>SIN REVISIONES</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Cantidad de riesgos">
        <template slot-scope="scope">
          <el-tag
            style="background-color: rgb(7, 116, 141); color: white; font-size: 19px;"
          >{{scope.row.riesgos.length}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Historial" min-width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.comentarios.length > 0" style="height: 100px; overflow: auto;">
            <div
              @click="viewComentarios(scope.row.comentarios)"
              v-for="(item, index) in scope.row.comentarios"
              :key="index"
              style="font-size: 12px; cursor: pointer;"
            >
              <b>Revisor:</b>
              {{getRole(item.revisor)}}
              <br />
              <b>Fecha:</b>
              {{item.fecha}}
              <br />
              <b>Comentario:</b>
              <br />
              {{item.comentario}}
              <div style="margin-top: 10px; margin-bottom: 10px;">
                <hr v-if="scope.row.comentarios[index + 1]" />
              </div>
            </div>
          </div>
          <el-tag type="primary" v-else>SIN COMENTARIOS</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Estado">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.aprobado === true">TAREA APROBADA</el-tag>
          <el-tag type="info" v-else>TAREA EN REVISIÓN</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <br />
    <div class="text-right">
      <el-button size="medium" type="primary" class="big-submit" @click="goBack()">{{$t('Volver')}}</el-button>
      <template v-if="($store.getters.role.admin || rolesCoordinator[$store.getters.role.role])">
        <el-button
          size="medium"
          v-if="!inventario.status || inventario.status == 0"
          type="primary"
          @click="goToTasks()"
          class="big-submit"
        >{{ $t('Seguir editando') }}</el-button>
      </template>
    </div>

    <!--Dialog otras versiones-->
    <el-dialog
      :before-close="handleClose"
      :title="$t('Versiones anteriores')"
      :visible="otherVersionsDialog"
      width="20%"
    >
      <div class="text-center">
        <div v-for="(url, date) in oldVersions" :key="date">
          <el-button
            class="pdfDate"
            @click="abrirOldPDF(url)"
            type="default"
            round
          >{{ date | formatDateHour }}</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="otherVersionsDialog = false">{{ $t('Cerrar') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :before-close="handleClose"
      :title="$t('Procedimiento')"
      :visible="ver_modal_procedimiento ? true: false"
      width="40%"
    >
      <div class="text-center">{{ver_modal_procedimiento}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ver_modal_procedimiento = false">{{ $t('Cerrar') }}</el-button>
      </span>
    </el-dialog>

    <!-- Dialog confirmación medioambiente -->
    <el-dialog
      :title="$t('Validación Medioambiental')"
      :visible="environmentalConfirmationDialog"
      width="40%"
    >
      <!-- Body -->
      <br />
      <div v-if="environmentalValidation.valido">
        Al validar este inventario sin riesgos o aspectos medioambientales
        el inventario pasará a su proceso de revisión.
        <br />
        <br />¿Seguro desea validar el inventario sin riesgos o aspectos medioambientales?
      </div>
      <div v-else>
        Debe ingresar la razón por la cual rechaza el inventario
        sin riesgos o aspectos medioambientales. Este comentario será
        enviado al coordinador para que modifique el inventario de riesgos.
        <br />
        <br />
        <el-input
          type="textarea"
          placeholder="Ingrese motivo del rechazo"
          v-model="environmentalValidation.comentario"
        ></el-input>
      </div>
      <!-- Footer -->
      <br />
      <div style="text-align: right;">
        <el-button size="small" @click="environmentalConfirmationDialog = false">{{ $t('Cerrar') }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="sendEnvironmentalValidation"
        >{{ $t('Enviar validación') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="800pt"
      :show-close="false"
      :before-close="() => procedurePdf = false"
      :visible="procedurePdf"
    >
      <div class="iframeContainer">
        <embed
          v-if="selectedProcedure.pdf_document"
          :src="selectedProcedure.pdf_document"
          type="application/pdf"
          width="100%"
          height="612pt"
          style="width:100%;height:612pt;border:solid #424242;"
        />
        <div v-else>
          <h4>este procedimiento aun no tiene un pdf</h4>
          <h4 v-if="[null, 0].includes(selectedProcedure.status)">procedimiento aun en borrador</h4>
          <ul>
            <li>Título: {{selectedProcedure.title}}</li>
            <li>Subtítulo: {{selectedProcedure.subtitle}}</li>
            <li>Código: {{selectedProcedure.serial}}</li>
          </ul>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :before-close="closeDialogVerificarEstado"
      width="30%"
      :title="$t('REVISIÓN')"
      :visible="dialogVerificarEstado"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form label-position="top">
        <div>
          <el-form-item :label="$t('Estado')">
            <el-select
              v-model="checkTask"
              :placeholder="$t('Por favor revise la tarea')"
              size="large"
              class="with-help-box full-width"
            >
              <el-option :label="$t('Revisado sin comentarios')" :value="true"></el-option>
              <el-option :label="$t('Revisado con comentarios')" :value="false"></el-option>
            </el-select>
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Estado')"
              width="200"
              trigger="hover"
              :content="$t('Seleccione el estado de aprobación de la tarea. Si no aprueba la evaluación de la tarea, debe seleccionar \'Revisado con comentarios\'.')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label="Comentario" v-if="checkTask === false">
            <el-input
              class="with-help-box"
              placeholder="Ingrese su comentario"
              type="textarea"
              :rows="2"
              v-model="comentario"
            />
            <el-popover
              class="help-box"
              placement="top"
              title="Comentario"
              width="200"
              trigger="hover"
              :content="$t(`Especifique el motivo del rechazo de la tarea para que
              el  \'Coordinador \' corrija el riesgo.`)"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogVerificarEstado()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="saveVerificarEstado()">{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="15px"
      :before-close="closeChangeRisk"
      :title="$t('Modificando Riesgo o Aspecto Ambiental')"
      width="99%"
      :visible="dialogChangeRiskVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <p>{{$t('A continuación puede modificar el riesgo según lo indicado por el revisor. Por favor, verifique bien antes de guardar.')}}</p>
      <InventarioBowtie
        :taskName="task.nombre"
        :editable="true"
        :editRisk="true"
        :risk="this.actualRisk"
        :addCause="addCause"
        :deleteCause="deleteCause"
        :editCause="editCause"
        :addImpact="addImpact"
        :deleteImpact="deleteImpact"
        :editImpact="editImpact"
        :addPreventiveControl="addPreventiveControl"
        :deletePreventiveControl="deletePreventiveControl"
        :editPreventiveControl="editPreventiveControl"
        :addMitigationControl="addMitigationControl"
        :deleteMitigationControl="deleteMitigationControl"
        :editMitigationControl="editMitigationControl"
        :addEvaluator="addEvaluator"
        :deleteEvaluator="deleteEvaluator"
        :editEvaluator="editEvaluator"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangeRisk()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="saveRisk()">{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Historial de comentarios"
      :visible.sync="openDialogComentario"
      width="30%"
      :before-close="handleClose"
    >
      <br />
      <div style="height: 364px; overflow: auto;">
        <el-card
          v-for="(item, index) in comentarios"
          :key="index"
          style="font-size: 14px; margin-bottom: 20px;"
        >
          <el-form label-position="right">
            <el-form-item style="margin-bottom: 0px;" label="Revisor:">{{getRole(item.revisor)}}</el-form-item>
            <el-form-item style="margin-bottom: 0px;" label="Fecha:">{{item.fecha}}</el-form-item>
            <el-form-item style="margin-bottom: 0px;" label="Comentario:">{{item.comentario}}</el-form-item>
          </el-form>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="openDialogComentario = false">Cerrar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import { canChangeRisk } from "@/utils/generalFunctions";
import { ENDPOINT_PROCEDURE } from "@/config.js";
import InventarioBowtie from "@/components/InventarioBowtie.vue";
import InventarioTable from "./InventarioTable.vue";
import {
  getProcedures,
  getProcedure,
  getInventoryDatas
} from "@/procedures/requests.js";

export default {
  props: {
    inventory: {
      type: Object,
      required: true
    },
    contractPeople: {
      type: Array
    },
    contract: {
      type: Object,
      required: true
    },
    workflows: {
      type: Array,
      required: true
    },
    filtro_usuario_riesgo: {
      default: false
    }
  },
  components: {
    InventarioTable,
    InventarioBowtie
  },
  data() {
    return {
      comentarios: [],
      openDialogComentario: false,
      task: {},
      checkTask: true,
      comentario: "",
      dialogVerificarEstado: false,
      actualTask: {},
      window,
      procedurePdf: false,
      selectedProcedure: {},
      rolesCoordinator: {
        contractor_coordinator: true,
        coordinator: true
      },
      ver_modal_procedimiento: false,
      inventario_estado: {
        undefined: "No iniciado",
        0: "Borrador",
        1: "En revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente"
      },
      risk_copy: {},
      filtro_tipo_riesgo: {
        "Salud y Seguridad": true,
        "salud y seguridad": true,
        salud: true,
        seguridad: true,
        medioambiente: true
      },
      dialogChangeRiskVisible: false,
      actualRisk: false,
      isLoading: false,
      isLoadingPDF: false,
      isLoadingPDFTask: false,
      activeTab: "aprobaciones",
      otherVersionsDialog: false,
      oldVersions: {},
      medioambiental: false,
      isLoadingPDFMedioambiente: false,
      isIE11: false,
      roles: [],
      task: {},
      auxTasks: null,
      taskShowObj: {},
      roleCoordinator: {
        coordinator: true,
        contractor_coordinator: true
      },
      environmentalAlertText: `
        <b>Inventario sin Riesgos/Aspectos Medioambientales</b><br>
        <p>
          El inventario de riesgos actual no contiene registro de riesgos o
          aspectos medioambientales en ninguna de las tareas definidas.<br>
          Por lo anterior es necesario que un especialista de medioambiente valide que esto
          sea correcto.<br>
          Para validar presione el boton <b>"Validar inventario sin riesgos Medioambientales"</b>, en caso
          contrario, presione "Rechazar" y deje un mensaje al Coordinador para que resuelva la situación.
        </p>
      `,
      environmentalValidation: {
        valido: false,
        comentario: "",
        fecha_validacion: new Date(),
        user_id: this.$store.getters.user._id
      },
      environmentalConfirmationDialog: false,
      customProcedures: [],
      standarProcedures: []
    };
  },
  watch: {
    "$store.getters.inventario": {
      handler(after, before) {
        this.setAuxTasksAndRiskAlert();
      },
      deep: true
    }
  },
  created() {
    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    const vue = this;
    if (this.inventario.tareas !== undefined) {
      getProcedures({
        is_deleted: false,
        last_version: true,
        job_id: this.$store.getters.role.faena_id,
        contract_id: this.contract._id || this.contract.id
      })
        .then(r => (this.customProcedures = r))
        .catch(e => console.error(e));

      getInventoryDatas({ inventory_id: this.contract._id || this.contract.id })
        .then(r => (this.standarProcedures = r))
        .then(r => console.log(this.standarProcedures, "<---s"))
        .catch(e => console.error(e));

      this.inventario.tareas.forEach(tarea => {
        // Evita renderización automatica
        this.taskShowObj[tarea.id || tarea._id] = false;
        // Mostrar o no pdf medioambiental
        if (tarea.riesgos && !vue.medioambiental) {
          tarea.riesgos.forEach(riesgo => {
            if (riesgo.medioambiental) {
              vue.medioambiental = true;
            }
          });
        }
      });
      this.setAuxTasksAndRiskAlert();
    }
    this.$store.dispatch("setStatus", this.inventario.status);
  },
  computed: {
    ...mapGetters({
      actualRole: "actualRole"
    }),
    role() {
      return this.$store.getters.role;
    },
    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
    activeTasks() {
      if (this.inventario.tareas === undefined) return undefined;
      return this.inventario.tareas.map(tarea => tarea.id || tarea._id);
    },
    inventario() {
      return this.inventory;
    },
    actualContract() {
      return this.contract;
    },
    actualRole() {
      if (!this.$store.getters.role) return false;
      if (!this.$store.getters.role.role) return false;
      return this.$store.getters.role.role;
    },
    isAdmin() {
      return this.$store.getters.role.admin;
    }
  },
  methods: {
    getInventario() {
      var self = this;
      if (!this.filtro_usuario_riesgo) {
        return this.inventario.tareas;
      } else {
        if (this.isAdmin === true) {
          return this.inventario.tareas;
        } else {
          var workflow = this.workflows.find(
            x => x._id === this.contract.workflow
          );
          if (
            this.$store.getters.role.role !== "contractor_coordinator" &&
            this.$store.getters.role.role !== "coordinator"
          ) {
            return this.inventario.tareas
              .filter(function(el) {
                return el.paso !== -1;
              })
              .filter(function(el) {
                return workflow.pasos[el.paso].roles.includes(
                  self.$store.getters.role.role
                );
              });
          } else {
            return this.inventario.tareas.filter(function(el) {
              return el.paso === -1;
            });
          }
        }
      }
    },
    isCoordinatorRole(role) {
      var creator = ["coordinator", "contractor_coordinator"];
      if (creator.includes(role)) {
        return true;
      } else {
        return false;
      }
    },
    viewComentarios(comentarios) {
      this.comentarios = comentarios;
      this.openDialogComentario = true;
    },
    getRole(rol) {
      let roles = {
        superadmin: "Administrador de Plataforma",
        contractor_coordinator: "Coordinador Contratista",
        contractor_hse: "GSSO Contratista",
        administrator: "Administrador de Contratos",
        coordinator: "Coordinador",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgos",
        hse: "GSSO",
        health: "Especialista Salud",
        safety: "Especialista Seguridad",
        environment: "Especialista Medioambiente",
        manager: "Gerente",
        super: "Superintendente"
      };
      return roles[rol];
    },
    async deleteRisk(risk) {
      try {
        await this.$confirm(
          this.$t(
            "Esta acción eliminará este riesgo de manera permanente. Desea continuar?"
          ),
          this.$t("Advertencia"),
          {
            confirmButtonText: this.$t("Eliminar"),
            cancelButtonText: this.$t("Cancelar"),
            type: "warning"
          }
        );
        const response = await this.$store.dispatch("deleteRiskReviewed", {
          inventory_id: this.$store.getters.inventario._id,
          task_id: this.task._id || this.task.id,
          risk
        });

        if (response.status) {
          await this.$store.dispatch("getInventory", this.contract);
          this.$alert(
            this.$t("Riesgo eliminado exitosamente."),
            this.$t("Atención"),
            {
              type: "success"
            }
          );
          let c_task = this.inventario.tareas.find(
            x => x._id === this.task._id
          );
          let pos = c_task.riesgos
            .map(function(e) {
              return e._id;
            })
            .indexOf(risk._id);
          if (pos !== -1) {
            c_task.riesgos.splice(pos, 1);
          }
        } else {
          this.$alert(
            this.$t(
              "Lo sentimos, surgió un error al eliminar el riesgo. Intente nuevamente."
            ),
            this.$t("Atención"),
            {
              type: "error"
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    setTask(new_task) {
      let task = JSON.parse(JSON.stringify(new_task));
      delete task.riesgos;
      this.task = task;
    },
    updateRisk() {
      this.$confirm(
        this.$t(
          "Estos cambios serán sujetos a revisión. ¿Está seguro de continuar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.$store
          .dispatch("updateRiskReviewed", {
            inventory_id: this.$store.getters.inventario._id,
            task_id: this.task.id || this.task._id,
            risk: this.actualRisk
          })
          .then(response => {
            if (response.status === true) {
              this.$store.dispatch("getInventory", this.contract);
              this.$alert(
                this.$t("Riesgo actualizado exitosamente."),
                this.$t("Atención"),
                {
                  type: "success"
                }
              );
              this.dialogChangeRiskVisible = false;
            } else {
              this.$alert(
                this.$t(
                  "Lo sentimos, surgió un error al actualizar el riesgo. Intente nuevamente."
                ),
                this.$t("Atención"),
                {
                  type: "error"
                }
              );
            }
          });
      });
    },
    saveRisk() {
      if (JSON.stringify(this.actualRisk) === JSON.stringify(this.risk_copy)) {
        this.$confirm(
          this.$t(
            "No has realizado ningún cambio en el riesgo, estás seguro que deseas continuar?"
          ),
          this.$t("Atención"),
          { type: "warning" }
        ).then(() => {
          this.updateRisk();
        });
      } else {
        this.updateRisk();
      }
    },
    closeChangeRisk() {
      this.$confirm(
        this.$t(
          "Se perderán todos los cambios que haya realizado. ¿Está seguro de cancelar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.dialogChangeRiskVisible = false;
      });
    },
    editEvaluator(evaluator, evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        evaluator => evaluator.id === evaluadorId
      );
      Vue.set(this.actualRisk.evaluadores, evaluatorIndex, {
        ...this.actualRisk.evaluadores[evaluatorIndex],
        nombre: evaluator.nombre,
        rut: evaluator.rut,
        cargo: evaluator.cargo,
        empresa: evaluator.empresa
      });
    },
    deleteEvaluator(evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        evaluator => evaluator.id === evaluadorId
      );
      Vue.delete(this.actualRisk.evaluadores, evaluatorIndex);
    },
    addEvaluator(pEvaluator) {
      if (!this.actualRisk.evaluadores) {
        this.actualRisk.evaluadores = [];
      }
      const evaluator = {
        ...pEvaluator,
        id: uuid()
      };
      this.actualRisk.evaluadores.push(evaluator);
    },
    editMitigationControl(control, controlId) {
      this.actualRisk.impactos.forEach((impact, impactIndex) => {
        // Se busca si este impacto ya tiene este control asignado
        let controlIndex = -1;
        if (impact.controles_mitigadores) {
          controlIndex = impact.controles_mitigadores.findIndex(
            control => control.id === controlId
          );
        }

        // El control editado, tiene asociada este impacto?
        if (control.impacto === impact.id) {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            console.log(`actualiza ${impact.categoria} en ${control.nombre}`);
            Vue.set(
              this.actualRisk.impactos[impactIndex].controles_mitigadores,
              controlIndex,
              {
                ...this.actualRisk.impactos[impactIndex].controles_mitigadores[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico
              }
            );
          } else {
            // Agregar control a impacto
            console.log(`agregando ${impact.categoria} en ${control.nombre}`);
            const controlMitigador = {
              id: uuid(),
              nombre: control.nombre,
              critico: control.critico
            };
            this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
              controlMitigador
            );
          }
          // El control editado no tiene este impacto asociada actualmente
        } else {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            // Entonces se borra
            console.log(`borrando ${impact.categoria} de ${control.nombre}`);
            Vue.delete(
              this.actualRisk.impactos[impactIndex].controles_mitigadores,
              controlIndex
            );
          }
        }
      });
    },
    deleteMitigationControl(impactoId, controlId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      const controlIndex = this.actualRisk.impactos[
        impactIndex
      ].controles_mitigadores.findIndex(control => control.id === controlId);
      Vue.delete(
        this.actualRisk.impactos[impactIndex].controles_mitigadores,
        controlIndex
      );
    },
    addMitigationControl(impactoId, control) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      if (!this.actualRisk.impactos[impactIndex].controles_mitigadores) {
        Vue.set(this.actualRisk.impactos, impactIndex, {
          ...this.actualRisk.impactos[impactIndex],
          controles_mitigadores: []
        });
      }
      const controlMitigador = {
        id: uuid(),
        nombre: control
      };
      this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
        controlMitigador
      );
    },
    editPreventiveControl(control, controlId) {
      this.actualRisk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            control => control.id === controlId
          );
        }

        // El control editado, tiene asociada esta causa?
        if (control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            console.log(`actualiza ${cause.nombre} en ${control.nombre}`);
            Vue.set(
              this.actualRisk.causas[causeIndex].controles_preventivos,
              controlIndex,
              {
                ...this.actualRisk.causas[causeIndex].controles_preventivos[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico
              }
            );
          } else {
            // Agregar control a causa
            console.log(`agregando ${cause.nombre} en ${control.nombre}`);
            const controlPreventivo = {
              id: controlId,
              nombre: control.nombre,
              critico: control.critico
            };
            if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
              Vue.set(this.actualRisk.causas, causeIndex, {
                ...this.actualRisk.causas[causeIndex],
                controles_preventivos: []
              });
            }
            this.actualRisk.causas[causeIndex].controles_preventivos.push(
              controlPreventivo
            );
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            console.log(`borrando ${cause.nombre} de ${control.nombre}`);
            Vue.delete(
              this.actualRisk.causas[causeIndex].controles_preventivos,
              controlIndex
            );
          }
        }
      });
    },
    deletePreventiveControl(causaId, controlId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        cause => cause.id === causaId
      );
      const controlIndex = this.actualRisk.causas[
        causeIndex
      ].controles_preventivos.findIndex(control => control.id === controlId);
      Vue.delete(
        this.actualRisk.causas[causeIndex].controles_preventivos,
        controlIndex
      );
    },
    addPreventiveControl(causasId, control) {
      causasId.forEach(causaId => {
        const causeIndex = this.actualRisk.causas.findIndex(
          cause => cause.id === causaId
        );
        if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
          Vue.set(this.actualRisk.causas, causeIndex, {
            ...this.actualRisk.causas[causeIndex],
            controles_preventivos: []
          });
        }
        const controlPreventivo = {
          id: uuid(),
          nombre: control
        };
        this.actualRisk.causas[causeIndex].controles_preventivos.push(
          controlPreventivo
        );
      });
    },
    editImpact(impacto, impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      Vue.set(this.actualRisk.impactos, impactIndex, {
        ...this.actualRisk.impactos[impactIndex],
        categoria: impacto.categoria,
        descripcion: impacto.descripcion,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl
      });
    },
    deleteImpact(impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      Vue.delete(this.actualRisk.impactos, impactIndex);
    },
    addImpact(impacto) {
      const impact = {
        id: uuid(),
        ...impacto
      };
      this.actualRisk.impactos.push(impact);
    },
    editCause(causa, causaID) {
      const causeIndex = this.actualRisk.causas.findIndex(
        cause => cause.id === causaID
      );
      Vue.set(this.actualRisk.causas, causeIndex, {
        ...this.actualRisk.causas[causeIndex],
        nombre: causa
      });
    },
    deleteCause(causaId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        cause => cause.id === causaId
      );
      Vue.delete(this.actualRisk.causas, causeIndex);
    },
    addCause(causa) {
      const cause = {
        id: uuid(),
        nombre: causa
      };
      this.actualRisk.causas.push(cause);
    },
    changeRisk(riesgo) {
      // Copia objeto para poder modificarlo
      this.risk_copy = JSON.parse(JSON.stringify(riesgo));
      if (!riesgo["medioambiente"]) {
        riesgo["medioambiente"] = {};
      }
      if (!riesgo["energia"]) {
        riesgo["energia"] = "";
      }
      if (!riesgo["peligro"]) {
        riesgo["peligro"] = "";
      }
      if (!riesgo["evento_no_deseado"]) {
        riesgo["evento_no_deseado"] = "";
      }
      if (!riesgo["sin_controles"]) {
        riesgo["sin_controles"] = {
          severidad: "",
          probabilidad: ""
        };
      }
      if (!riesgo["con_controles"]) {
        riesgo["con_controles"] = {
          severidad: "",
          probabilidad: ""
        };
      }
      if (!riesgo["control_adicional"]) {
        riesgo["control_adicional"] = "";
      }
      this.actualRisk = JSON.parse(JSON.stringify(riesgo));
      this.dialogChangeRiskVisible = true;
    },
    saveVerificarEstadoCoordinador(task) {
      this.$confirm(
        this.$t(
          `¿Está seguro que desea confirmar sus correcciones en los riesgos de la tarea ${task.nombre}? Un email de aviso será enviado`
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.$prompt("Ingrese un comentario", "Comentario", {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancel"
        }).then(comentario => {
          if (comentario.value !== "") {
            this.actualTask = task;
            // Revision normal
            this.actualTask.ultimo_revisor = `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
            this.actualTask.ultimo_rol_revisor =
              this.isAdmin === true ? "superadmin" : this.actualRole;
            this.actualTask.ultima_revision = this.$moment().format("LLLL");
            let fecha = this.$moment().format("LLLL");
            this.actualTask.revisores = [];
            this.actualTask.paso = this.actualTask.paso + 1;
            this.actualTask.comentarios.push({
              fecha: fecha,
              revisor: this.isAdmin === true ? "superadmin" : this.actualRole,
              comentario: comentario.value
            });
            this.actualTask.comentarios = this.actualTask.comentarios.reverse();
            const task_id = this.actualTask._id;
            // aqui se envia
            this.$store
              .dispatch("updateTaskStatus", {
                id: this.$store.getters.inventario._id,
                task_id: this.actualTask._id,
                task: this.actualTask
              })
              .then(response => {
                if (response.status) {
                  // busca si hay almenos 1 tarea sin aprobar
                  const resp = this.$store.getters.inventario.tareas.some(
                    t => t.aprobado == false
                  );
                  // si no hay entonces el inventario se aprobo
                  // si se aprobo hay que setear la var de contrato que se muestra en select a aprobado
                  if (resp === false) {
                    this.$store.commit("EDIT_INVENTORY", { status: 2 });

                    const inventoryId = this.$store.getters.inventario._id;
                    this.$store.dispatch("userContractAssignInventory", {
                      inventoryId,
                      obj: { status: 2 }
                    });
                    this.$store
                      .dispatch(
                        "setDateInventoryApproved",
                        this.$store.getters.inventario
                      )
                      .then(async response => {
                        if (response.status === true) {
                          console.log(
                            `Fecha de aprobación actualizada para el inventario ${this.$store.getters.inventario._id}`
                          );
                        } else {
                          console.log(
                            "La fecha de aprobación no ha podido actualizarse"
                          );
                        }
                      });
                  } // if

                  this.$alert(response.message, this.$t("Atención"), {
                    type: "success"
                  });
                  this.getStatus();
                } else {
                  this.$alert(
                    this.$t(
                      "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                    ),
                    this.$t("Atención"),
                    {
                      type: "error"
                    }
                  );
                } // if
              });

            this.closeDialogVerificarEstado();
          } else {
            this.$alert(
              this.$t(
                "No has ingresado ningún comentario, debes completar todos los campos para continuar."
              ),
              this.$t("Atención"),
              {
                type: "warning"
              }
            );
          }
        });
      });
    },
    saveVerificarEstado() {
      this.actualTask.ultimo_revisor = `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
      this.actualTask.ultimo_rol_revisor = this.actualRole;
      this.actualTask.ultima_revision = this.$moment().format("LLLL");
      var workflow = this.workflows.find(x => x._id === this.contract.workflow);

      if (this.checkTask === true) {
        this.comentario = "";
        this.$confirm(
          this.$t(
            "¿Está seguro de esta revisión? Un email de aviso será enviado"
          ),
          this.$t("Atención"),
          { type: "warning" }
        ).then(() => {
          // Revision normal
          this.actualTask.revisores.push(this.actualRole);
          const task_id = this.actualTask._id;
          let paso_actual = workflow.pasos[this.actualTask.paso];
          if (
            paso_actual.minAprobaciones === this.actualTask.revisores.length
          ) {
            if (!workflow.pasos[this.actualTask.paso + 1]) {
              this.actualTask.aprobado = true;
            } else {
              this.actualTask.paso = this.actualTask.paso + 1;
              this.actualTask.revisores = [];
            }
          }
          // aqui se envia
          this.$store
            .dispatch("updateTaskStatus", {
              id: this.$store.getters.inventario._id,
              task_id: this.actualTask._id,
              task: this.actualTask
            })
            .then(response => {
              if (response.status) {
                // busca si hay almenos 1 tarea sin aprobar
                const resp = this.$store.getters.inventario.tareas.some(
                  t => t.aprobado == false
                );
                // si no hay entonces el inventario se aprobo
                // si se aprobo hay que setear la var de contrato que se muestra en select a aprobado
                if (resp === false) {
                  this.$store.commit("EDIT_INVENTORY", { status: 2 });

                  const inventoryId = this.$store.getters.inventario._id;
                  this.$store.dispatch("userContractAssignInventory", {
                    inventoryId,
                    obj: { status: 2 }
                  });
                  this.$store
                    .dispatch(
                      "setDateInventoryApproved",
                      this.$store.getters.inventario
                    )
                    .then(async response => {
                      if (response.status === true) {
                        console.log(
                          `Fecha de aprobación actualizada para el inventario ${this.$store.getters.inventario._id}`
                        );
                      } else {
                        console.log(
                          "La fecha de aprobación no ha podido actualizarse"
                        );
                      }
                    });
                } // if

                this.$alert(response.message, this.$t("Atención"), {
                  type: "success"
                });
                this.getStatus();
              } else {
                this.$alert(
                  this.$t(
                    "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                  ),
                  this.$t("Atención"),
                  {
                    type: "error"
                  }
                );
              } // if
            });

          this.closeDialogVerificarEstado();
        });
      } else if (this.checkTask === false) {
        if (this.comentario === "") {
          this.$alert(
            this.$t(
              "No has ingresado ningún comentario, debes completar todos los campos para continuar."
            ),
            this.$t("Atención"),
            {
              type: "warning"
            }
          );
        } else {
          // Revision normal
          let fecha = this.$moment().format("LLLL");
          this.actualTask.revisores = [];
          this.actualTask.paso = -1;
          this.actualTask.comentarios.push({
            fecha: fecha,
            revisor: this.actualRole,
            comentario: this.comentario
          });
          this.actualTask.comentarios = this.actualTask.comentarios.reverse();
          const task_id = this.actualTask._id;
          // aqui se envia
          this.$store
            .dispatch("updateTaskStatus", {
              id: this.$store.getters.inventario._id,
              task_id: this.actualTask._id,
              task: this.actualTask
            })
            .then(response => {
              if (response.status) {
                // busca si hay almenos 1 tarea sin aprobar
                const resp = this.$store.getters.inventario.tareas.some(
                  t => t.aprobado == false
                );
                // si no hay entonces el inventario se aprobo
                // si se aprobo hay que setear la var de contrato que se muestra en select a aprobado
                if (resp === false) {
                  this.$store.commit("EDIT_INVENTORY", { status: 2 });

                  const inventoryId = this.$store.getters.inventario._id;
                  this.$store.dispatch("userContractAssignInventory", {
                    inventoryId,
                    obj: { status: 2 }
                  });
                  this.$store
                    .dispatch(
                      "setDateInventoryApproved",
                      this.$store.getters.inventario
                    )
                    .then(async response => {
                      if (response.status === true) {
                        console.log(
                          `Fecha de aprobación actualizada para el inventario ${this.$store.getters.inventario._id}`
                        );
                      } else {
                        console.log(
                          "La fecha de aprobación no ha podido actualizarse"
                        );
                      }
                    });
                } // if

                this.$alert(response.message, this.$t("Atención"), {
                  type: "success"
                });
                this.getStatus();
              } else {
                this.$alert(
                  this.$t(
                    "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                  ),
                  this.$t("Atención"),
                  {
                    type: "error"
                  }
                );
              } // if
            });

          this.closeDialogVerificarEstado();
        }
      }
    },
    getStatus() {
      this.loading = true;
      var self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      let role =
        this.$store.getters.role.admin === true
          ? "superadmin"
          : this.$store.getters.role.role;
      axios
        .get(
          `/inventarios/getStatusDashboardAmsa/${this.$store.getters.role.faena_id}/${role}/${this.$store.getters.user._id}/${this.$store.getters.role.area_id}/${this.$store.getters.role.empresa_id}`,
          config
        )
        .then(function(response) {
          // handle success
          self.$store.dispatch("setAllTareasPendientes", response.data);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },
    closeDialogVerificarEstado() {
      this.comentario = "";
      this.actualTask = {};
      this.dialogVerificarEstado = false;
    },
    openDialogVerificarEstado(task) {
      this.actualTask = task;
      this.dialogVerificarEstado = true;
    },
    proximoRevisor(task) {
      if (this.workflows) {
        let workflow = this.workflows.find(
          x => x._id === this.contract.workflow
        );
        if (workflow.pasos[task.paso + 1]) {
          let pasos = workflow.pasos[task.paso + 1];
          let next_roles = [];
          for (let i = 0; i < pasos.roles.length; i++) {
            next_roles.push(this.getRole(pasos.roles[i]));
          }
          return next_roles.toString();
        } else {
          return null;
        }
      }
    },
    actualRevisor(task) {
      if (task.paso === -1) {
        if (this.contract.tipo_contrato === "Contratista") {
          return this.getRole("contractor_coordinator");
        } else {
          return this.getRole("coordinator");
        }
      }
      if (this.workflows) {
        let workflow = this.workflows.find(
          x => x._id === this.contract.workflow
        );
        if (workflow.pasos[task.paso]) {
          let pasos = workflow.pasos[task.paso];
          let next_roles = [];
          for (let i = 0; i < pasos.roles.length; i++) {
            next_roles.push(this.getRole(pasos.roles[i]));
          }
          return next_roles.toString();
        } else {
          return null;
        }
      }
    },
    getControlesMitigadores(risk) {
      const controles = [];

      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;

          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach(control => {
              control.id_impacto = id;
              controles.push(control);
            });
          }
        });
      }

      return controles;
    },
    tablaControlCritico(risk) {
      if (risk.critico) {
        return "control-critico";
      }
    },
    getControlesPreventivos(risk) {
      const controles = [];
      const controlesId = {};

      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const id = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach(control => {
              if (!controlesId[control.nombre]) {
                controlesId[control.nombre] = true;
                control.id_causa = id;
                controles.push(control);
              }
            });
          }
        });
      }

      return controles;
    },
    MaysPrimera(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    findProcedure(task) {
      const tId = task.id || task._id;
      const cp = this.customProcedures.find(p => p.task_id === tId);
      const sp = this.standarProcedures.find(p => p.task_id === tId);
      return cp || sp;
    },
    selectProcedure(task) {
      const tId = task.id || task._id;
      const cp = this.customProcedures.find(p => p.task_id === tId);
      const sp = this.standarProcedures.find(p => p.task_id === tId);

      this.selectedProcedure = cp || sp;
      if (sp) {
        getProcedure(sp.procedure).then(p => {
          this.selectedProcedure = p;
          this.procedurePdf = true;
        });
      } else {
        this.selectedProcedure = cp;
        this.procedurePdf = true;
      }
    },

    isActiveContract(contract) {
      if (contract.tipo_contrato === "Propio") return true;
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    collapse_change(array) {
      array.forEach(e => {
        // solo entra una vez para evitar el uso de forceUpdate inecesariamente
        if (this.taskShowObj[e] === false) {
          this.taskShowObj[e] = true;
          this.$forceUpdate();
        } // if
      });
    },
    goBack() {
      window.history.go(-1);
    },
    handleClose() {
      this.otherVersionsDialog = false;
      this.openDialogComentario = false;
    },
    shortStr(nombre) {
      if (!nombre) return "";
      return nombre.length > 80 ? `${nombre.substr(0, 80)}...` : nombre;
    },
    async getInventory() {
      // Recupera inventario del contrato
      if (
        !(
          this.$store.getters.inventario &&
          this.$store.getters.inventario.contrato_id === this.contract._id
        )
      ) {
        const self = this;
        await this.$store.dispatch("getInventory", this.contract).then(() => {
          self.inventario = self.$store.getters.inventario;
        });
      }
    },
    setAuxTasksAndRiskAlert() {
      try {
        let taskId = "default";
        this.auxTasks = {};
        let canChange;
        this.auxTasks[taskId] = { tarea_id: "default", count: 0 };

        if (this.inventario.tareas) {
          this.inventario.tareas.forEach(tarea => {
            taskId = tarea._id || tarea.id;
            this.auxTasks[taskId] = { count: 0, show: false };
            // Mapear los riesgos
            if (tarea.riesgos) {
              tarea.riesgos.forEach(riesgo => {
                canChange = this.roleCoordinator[this.actualRole]
                  ? this.canChangeRisk
                  : this.canReviewTask;

                // Contar riesgos a evaluar por el usuario revisor
                if (canChange(riesgo)) {
                  this.auxTasks[taskId].count += 1;
                } // if
              }); // forEach
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    canChangeRisk(risk) {
      return canChangeRisk({ risk, profile: this.actualRole });
    },
    canReviewTask(task, workflows, contract) {
      try {
        // Ya no en revisión
        if (task.aprobado === true) return false;

        // Coordinador editando
        if (parseInt(task.paso) === -1) return false;

        if (task.revisores && task.revisores.includes(this.actualRole)) {
          return false;
        }

        if (workflows) {
          let workflow = workflows.find(x => x._id === contract.workflow);
          if (workflow.pasos[task.paso]["roles"].includes(this.actualRole)) {
            return true;
          }
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    canFix(task, workflows, contract) {
      try {
        // Coordinador editando
        if (parseInt(task.paso) === -1) return true;
        return false;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    otherVersions() {
      this.listPDFs();
      this.otherVersionsDialog = true;
    },
    goToTasks() {
      const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
      this.$router.push({
        path: url
      });
    },

    async downloadPDF() {
      this.isLoadingPDF = true;
      this.$store.dispatch("getLastPDF").then(() => {
        this.isLoadingPDF = false;
      });
    },
    downloadPDFReview() {
      this.isLoadingPDF = true;
      this.$store.dispatch("getReviewPDF").then(() => {
        this.isLoadingPDF = false;
      });
    },
    downloadPDFMedioambiente() {
      this.isLoadingPDFMedioambiente = true;
      this.$store.dispatch("getPDFMedioambiente").then(() => {
        this.isLoadingPDFMedioambiente = false;
      });
    },
    downloadPDFTask(id) {
      this.isLoadingPDFTask = true;
      this.$store
        .dispatch("getPDFTask", {
          inventory_id: this.$store.getters.inventario._id,
          task_id: id
        })
        .then(() => {
          this.isLoadingPDFTask = false;
        });
    },
    abrirOldPDF(url) {
      const windowReference = window.open();
      windowReference.location = url;
    },
    listPDFs() {
      const vue = this;
      this.$store.dispatch("getPDFs").then(response => {
        response.forEach(element => {
          const date = element
            .split("/")
            .pop()
            .split(".")
            .shift(); // returns 'two'
          Vue.set(vue.oldVersions, date, element);
        });
      });
    },
    async changeStatus(status) {
      this.isLoading = true;
      if (status === "borrador") {
        try {
          await this.$confirm(
            this.$t(`Al cambiando el estado de este inventario a borrador, 
            perderá el avance del flujo de revisión de los riesgos actualmente 
            en curso. ¿Seguro que desea continuar?`),
            this.$t("Atención"),
            {
              type: "warning"
            }
          );
          await this.$store.dispatch("setInventoryStatus", 0); // deja a inventario en status 0
        } catch (error) {
          return; // retorna si elige cancelar
        }
      }

      await this.$store.dispatch(
        "setInventario",
        this.$store.getters.inventario
      );

      // cuando el nuevo estado es borrador
      if (this.$store.getters.inventario.status === 0) {
        try {
          const resp = await this.$store.dispatch("createOrUpdateDraft");
          this.isLoading = false;
          if (resp.success) {
            this.$store.dispatch(
              "getInventory",
              this.$store.getters.actualContract
            );

            this.$alert(
              this.$t("Inventario modificado exitosamente"),
              this.$t("Atención"),
              {
                type: "success"
              }
            );
            // var local de lista de contratos
            const inventoryId = this.$store.getters.inventario._id;
            this.$store.dispatch("userContractAssignInventory", {
              inventoryId,
              obj: { status: 0 }
            });

            this.$router.push({ name: "inventorySelectPage" });
          } else {
            this.$alert(resp.message, this.$t("Atención"), {
              type: "error"
            });
          }
        } catch (error) {
          console.log("-->", error);
          this.$alert(
            this.$t("Ha ocurrido un error. Por favor, intente nuevamente."),
            this.$t("Atención"),
            {
              type: "error"
            }
          );
        }
      } else {
        const response = await this.$store.dispatch("saveInventario");
        this.isLoading = false;
        if (response.status) {
          this.$store.dispatch(
            "getInventory",
            this.$store.getters.actualContract
          );
          this.$alert(
            this.$t("Inventario modificado exitosamente"),
            this.$t("Atención"),
            {
              type: "success"
            }
          );
          this.$router.push({ name: "inventorySelectPage" });
        } else {
          this.$alert(response.message, "Atención", {
            type: "error"
          });
        }
      }
    },
    openEnvironmentalConfirmationDialog(valid) {
      this.environmentalValidation.valido = valid;
      this.environmentalConfirmationDialog = true;
    },
    async sendEnvironmentalValidation() {
      this.isLoading = true;

      // Definir estado del inventario
      // 0: Borrador, 1: En Revisión, 2: Aprobado, 3: Importado, 4: Validación Medioambiente
      let status = 4;
      if (this.environmentalValidation.valido) {
        status = 1;
      } else {
        status = 0;
      } // if

      // Set Inventario y validación medioambiental
      const inventario = Object.assign({}, this.inventory);
      inventario.status = status;
      if (!inventario.validacion_medioambiental) {
        inventario.validacion_medioambiental = [];
      }
      this.environmentalValidation.fecha_validacion = new Date();
      inventario.validacion_medioambiental.push(this.environmentalValidation);

      console.log(inventario);
      // Registrar cambios en BD
      this.$store.dispatch("setInventario", inventario).then(() => {
        this.$store.dispatch("saveInventario").then(async response => {
          this.isLoading = false;
          if (response.status) {
            this.$alert(
              this.$t("Validación/Rechazo registrado exitosamente"),
              this.$t("Atención"),
              {
                type: "success"
              }
            );
            // actualizar el contrato en el lado cliente
            const { userContracts } = this.$store.getters;
            const contractToUpdate = userContracts.find(
              c => c._id === this.contract._id
            );
            if (contractToUpdate) {
              console.log({ contractToUpdate });
              const invToUp = { ...contractToUpdate.inventario };
              console.log({ invToUp });
              if (invToUp) {
                invToUp.status = status;
                this.$store.dispatch("contractAssign", {
                  obj: contractToUpdate,
                  val: { inventario: invToUp }
                });
              } // if
            } // if
            // Redireccón a seleccón de inventarios
            this.$router.push({ name: "inventorySelectPage" });
          } else {
            this.$alert(response.message, "Atención", {
              type: "error"
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.centrar {
  text-align: center;
}
.estadoHeader {
  margin-top: 50px;
  text-align: center;
}

.estadoHeader .el-tag {
  font-size: 22px;
  height: auto;
  line-height: normal;
  padding: 5px 40px;
}

.info {
  margin-bottom: 60px;
}

.pdfDate {
  margin-bottom: 10px !important;
}

#modify-status .el-tag {
  margin: 0 10px;
}

.contenedor_tarea {
  width: 100%;
  position: absolute;
  z-index: 2;
}
.inventario_estado {
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-top: 5px;
  border-radius: 3px;
  margin-right: 15px;
}
.inventario_estado_vencido {
  background-color: #b84858;
}
.inventario_estado_undefined {
  background-color: red;
}
.inventario_estado_0 {
  background-color: grey;
}
.inventario_estado_1 {
  background-color: #e4d306;
}
.inventario_estado_2 {
  background-color: #6bc45b;
}
.inventario_estado_3 {
  background-color: orange;
}
.inventario_estado_4 {
  background-color: #e4d306;
}
.img_pdf {
  height: 30px;
  margin-bottom: 5px;
}
.button_img {
  vertical-align: middle;
  border: none;
  padding: 0;
  margin-right: 15px;
}
.margen_r_l_20px {
  margin-right: 20px;
  margin-left: 20px;
}
.img-change-status {
  margin-top: 10px;
}
.dislplay_0 {
  display: none;
}
.text_align_right {
  text-align: right;
}
.paddingContent {
  padding-bottom: 10px;
}
.font_size_22px {
  font-size: 18px;
}
.border_color_grey {
  border-color: grey;
}
.color_grey {
  color: #404040;
}

.tableTask {
  max-height: 60vh;
  overflow: scroll;
  overflow-x: hidden;
}
</style>

<style>
.el-table__expanded-cell {
  padding: 0px !important;
}
</style>
